import React from 'react';
import type { ComponentProps, ReactElement } from 'react';

import { useSize, type SizeType } from '../../../../features/config';
import { Text } from '../../../Typography';

type BreadcrumbTextProps = {
    size?: SizeType;
} & ComponentProps<typeof Text>;

const getTextType = (size: SizeType) => {
    if (size === 'small') return 'small';
    if (size === 'large') return 'h5';
    return 'text';
};

export const BreadcrumbText = ({
    children,
    size,
    ...textProps
}: BreadcrumbTextProps): ReactElement => {
    const mergedSize = useSize(size, 'medium', 'BreadcrumbText');
    return (
        <Text type={getTextType(mergedSize)} truncate {...textProps}>
            {children}
        </Text>
    );
};
